module.exports = __webpack_public_path__ + "img/lghor.a516d775.png";